import { render } from "./ProjectManagement.vue?vue&type=template&id=1cac1d08&scoped=true"
import script from "./ProjectManagement.vue?vue&type=script&lang=js"
export * from "./ProjectManagement.vue?vue&type=script&lang=js"

import "./ProjectManagement.vue?vue&type=style&index=0&id=1cac1d08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cac1d08"],['__file',"src/components/admin/ProjectManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cac1d08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cac1d08', __exports__)) {
    api.reload('1cac1d08', __exports__)
  }
  
  module.hot.accept("./ProjectManagement.vue?vue&type=template&id=1cac1d08&scoped=true", () => {
    api.rerender('1cac1d08', render)
  })

}


export default __exports__